<template>
  <div style="min-height: 92vh">
    <div>
      <h3>Familias de Productos</h3>
      <uv-data-table :config="config" :data="Categories" :pageRows="15" @buttonClick="dtButtonClick"></uv-data-table>
    </div>
    <modal v-model="showModal" :showFooter="false" title="Familias de productos">
      <familiasForm :edit="editMode" @toggle="toggleModal" :key="formIndex" :dataEdit="editData"
        @successData="successData"></familiasForm>
    </modal>
  </div>
</template>

<style></style>

<script>
import modal from "../../MainComponents/modal.vue";

import uvDataTable from "../../MainComponents/DataTable.vue";
import familiasForm from "../Familias/FamiliasForm.vue";

export default {
  name: "FamiliasCRUD",
  components: {
    modal,
    uvDataTable,
    familiasForm,
  },
  props: [],
  data() {
    return {
      self: this,
      showModal: false,
      formKey: 0,
      Categories: [],
      formIndex: 0,
      editMode: false,
      editData: [],
      config: {
        selectableRow: true,
        allowExport: true,
        rawText: "Familias",
        selectConfig: {
          idRowData: "id", // id necesario para indicar id unico del row que esta seleccionado y retornarlo en los eventos requeridos
        },
        orderByCol: { Field: "", Type: "Asc" },
        buttons: [
          {
            text: "Agregar",
            icon: "lni lni-plus",
            buttonId: "addFamilias",
          },
          {
            text: "Editar",
            icon: "lni lni-pencil-alt",
            buttonId: "editFamilias",
            require: true,
          },
          {
            text: "Eliminar",
            icon: "lni lni-trash",
            buttonId: "deleteFamilias",
            require: true,
          },
        ],
        fields: [
          {
            title: "Nombre",
            dataName: "Nombre",
            text: "Nombre",
            value: "Nombre",
          },
          {
            title: "Clave SAT",
            dataName: "CVESAT",
            text: "Clave SAT",
            value: "CVESAT",
          },
        ],
      },
    };
  },
  methods: {
    dtButtonClick(buttonId, idSelected) {
      if (buttonId == "addFamilias") {
        this.formIndex++;
        this.editMode = false;
        this.editData = {};
        this.showModal = true;
      }
      if (buttonId == "deleteFamilias") {
        this.deleteCategoria(idSelected[0]);
      }
      if (buttonId == "editFamilias") {
        this.formIndex++;
        this.editMode = true;
        this.editData = this.getCategoryById(idSelected[0]);
        this.$pgsHelper.log(this.editData);
        this.showModal = true;
      }
    },
    getCategoryById(code) {
      let itemIndex = this.$_.findIndex(this.Categories, { id: code });
      if (itemIndex >= 0) {
        return this.Categories[itemIndex];
      }

      return false;
    },
    successData(data, doAction) {
      if (doAction == "CREATE") {
        this.createCate(data);
      } else if (doAction == "EDIT") {
        this.editCate(data);
      }
    },
    createCate(datos) {
      this.$swal({
        title: "¿Deseas guardar la información de la Familia?",
        text: "La familia se almacenara y podra ser asignada a los productos",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("PDV-Productos-createFamilia", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          this.$emit("reloadClient");
          if (result.value.data.ok) {
            this.$pgsHelper.log(result.value);
            this.$swal({
              title: "Guardado",
              text: "La Familia se guardo correctamente",
              icon: "success",
            }).then(() => {
              this.toggleModal(false);
              this.getCategories();
            });
          } else {
            this.$swal(
              "Error saving Familia",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    editCate(datos) {
      this.$swal({
        title: "¿Deseas modificar la información de la Familia?",
        text: "La Familia se almacenara y podra ser asignada a los productos",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("PDV-Productos-updateFamilia", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          this.$emit("reloadClient");
          if (result.value.data.ok) {
            this.$pgsHelper.log(result.value);
            this.$swal({
              title: "Guardado",
              text: "La Familia se modifico correctamente",
              icon: "success",
            }).then(() => {
              this.toggleModal(false);
              this.getCategories();
            });
          } else {
            this.$swal(
              "Error saving Familia",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    async deleteCategoria(id) {
      this.$swal({
        title: "¿Deseas eliminar esta Familia?",
        text: "Se eliminara permanentemente",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          let data = { Id: id };
          return await this.$store.getters.getFirebaseApp.fba
            .call("PDV-Productos-deleteFamilia", data)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal(
              "Familia elimando",
              "La Familia se elimino correctamente",
              "success"
            );
            this.getCategories();
          } else {
            this.$swal("Error deleting data", result.value.data.error, "error");
          }
        }
      });
    },
    toggleModal(open) {
      this.showModal = open;
    },
    async getFamilias() {
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "PDV/Productos/Familias"
        );
      this.Categories = [];
      this.Categories = this.$pgsHelper.ArrayObjectToArray(data.val()) || [];
      return this.Categories;
    },
    async getCategories() {
      return this.getFamilias();
    },
  },
  computed: {},
  watch: {},
  mounted() { },
  created() {
    this.getCategories();
  },
};
</script>
